import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

export default function InstagramSection() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;

  const [settings, setSettings] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await axios.get(localhost + 'instagram');
      setSettings(res.data?.settings || null);
      setPosts(Array.isArray(res.data?.posts) ? res.data.posts : []);
    } catch (error) {
      // console.error('Error fetching instagram:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return null;

  const username = settings?.username || '';
  const profilePic = settings?.profile_pic ? localimg + settings.profile_pic : null;
  const profileLink =
    settings?.profile_url || (username ? `https://www.instagram.com/${username.replace(/^@/, '')}` : null);

  // Nothing configured yet — hide the section entirely.
  if (!profilePic && !username && posts.length === 0) return null;

  return (
    <section className="mt-12 sm:mt-16 lg:mt-20 border-t border-gray-200">
      {/* Profile block — centered */}
      <div className="flex flex-col items-center py-14 px-6">
        {profilePic && (
          <a href={profileLink || '#'} target="_blank" rel="noopener noreferrer" className="mb-4">
            <div className="w-24 h-24 rounded-full overflow-hidden border border-gray-200 hover:opacity-90 transition-opacity">
              <img src={profilePic} alt={username || 'Instagram'} className="w-full h-full object-cover" loading="lazy" />
            </div>
          </a>
        )}

        {username && (
          <a
            href={profileLink || '#'}
            target="_blank"
            rel="noopener noreferrer"
            className="uppercase text-gray-900 hover:opacity-70 transition-opacity"
            style={{ fontSize: '13px', letterSpacing: '0.2em', marginBottom: '18px' }}
          >
            @{username.replace(/^@/, '')}
          </a>
        )}

        {profileLink && (
          <a
            href={profileLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block uppercase font-medium border border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-colors duration-300"
            style={{ fontSize: '11px', letterSpacing: '0.18em', padding: '12px 30px' }}
          >
            {t('instagram-follow')}
          </a>
        )}
      </div>

      {/* Posts grid — full width, each image links to its own Instagram post */}
      {posts.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
          {posts.map((post) => (
            <a
              key={post.id}
              href={post.post_url}
              target="_blank"
              rel="noopener noreferrer"
              className="relative block overflow-hidden group"
              style={{ aspectRatio: '1 / 1' }}
            >
              <img
                src={localimg + post.image}
                alt=""
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </a>
          ))}
        </div>
      )}
    </section>
  );
}
